import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import ButtonIcon from "./button-icon";

const MAX_CONTENT_CHARS = 160;

const SwapCard = ({ item, itemClick }) => {
  const [showOverText, setShowOverText] = useState(false);
  const isDefaultHiddenText = item?.description?.length > MAX_CONTENT_CHARS;

  return (
    <div
      className="
      w-full group relative cursor-pointer border rounded-lg bg-inherit overflow-hidden
      hover:opacity-80 active:border-dashed active:border-gray-400 transition-all duration-300 ease-in-out"
    >
      {/* Item Image */}
      <div className="relative h-60 w-full">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover object-center"
        />
      </div>
      {/* Item Details */}
      <div className="mt-0 !text-left">
        <div className="p-4">
          <h3 className="text-gray-700 text-lg font-bold leading-6">
            <Link href="#">{item.title}</Link>
          </h3>

          {/* content details */}
          {item?.description &&
            <div className="mt-2 block w-full">
              <ReactMarkdown
                className={`text-sm text-gray-500 leading-[1.34rem] overflow-hidden ${
                  showOverText ? "line-clamp-none" : "line-clamp-3"
                } transition-all duration-300 ease-in-out`}
              >
                {item?.description}
              </ReactMarkdown>
              <button
                onClick={() => {
                  setShowOverText((prev) => !prev)
                }}
                className={`text-[0.70rem] outline-none inline-block text-gray-500 uppercase hover:underline hover:text-gray-700 tracking-wide ${
                  isDefaultHiddenText || showOverText
                    ? "opacity-100 pointer-events-auto"
                    : "opacity-0 pointer-events-none"
                }`}
              >
                {showOverText ? "read less .." : "read more .."}
              </button>
            </div>
          }
          
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex flex-col gap-2 p-4">
        {item.buttons && item.buttons.map((rawData, index) => {
          return (
            <button
              key={index}
              onClick={() => {
                itemClick(rawData)
              }}
              className="
              relative py-0.5 text-sm font-medium text-center text-clip block leading-9 rounded-md bg-gray-100 text-gray-600 tracking-wide 
              hover:bg-indigo-600 hover:text-white hover:shadow-md transition-all duration-300"
            >
              <ButtonIcon icon={rawData?.icon} alt={rawData?.title} />
              <span>{rawData.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

SwapCard.propTypes = {
  item: PropTypes.object,
  itemClick: PropTypes.func,
};

export default SwapCard;
